import { Navigate } from 'react-router-dom';

/**
 * F5-R4b · «Uploaders v2 — Actividad y cola» (dibujo del CEO, 2026-08-28):
 * las dos ventanas admin de uploaders se FUSIONAN en una sola pantalla con
 * conmutador. La «Cola de carga» vive ahora en /admin/uploaders-activity con
 * ?view=queue; esta ruta se conserva (AdminShell/AdminChrome no se tocan en
 * esta tanda — patrón BatchesListPage T6c) y redirige a la fusión. La entrada
 * del sidebar y el deep-link del NotificationsBell (/admin/uploader-team)
 * aterrizan directo en la vista de cola.
 *
 * Todo lo que esta página mostraba sigue vivo en la fusión, servido por los
 * mismos endpoints (/admin/uploader/team-stats + modal de screening readOnly).
 */
export function UploaderTeamPage(): JSX.Element {
  return <Navigate to="/admin/uploaders-activity?view=queue" replace />;
}
